import React from 'react';

export function SignOffBackground() {
    return (
        <>
            <div className="absolute inset-0 bg-green-500/5 pointer-events-none z-0" />
            <div className="absolute inset-0 pointer-events-none z-0">
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                    @keyframes wave-flow {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(-400px); }
                    }
                    .animate-wave-flow {
                        animation: wave-flow 20s linear infinite;
                    }
                `,
                    }}
                />
                <svg
                    className="w-full h-full"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1200 100"
                    preserveAspectRatio="none"
                >
                    <defs>
                        <linearGradient
                            id="waveGradient1"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="0%"
                        >
                            <stop
                                offset="0%"
                                stopColor="hsl(270 70% 60%)"
                                stopOpacity="0.04"
                            />
                            <stop
                                offset="50%"
                                stopColor="hsl(280 75% 65%)"
                                stopOpacity="0.12"
                            />
                            <stop
                                offset="100%"
                                stopColor="hsl(270 70% 60%)"
                                stopOpacity="0.04"
                            />
                        </linearGradient>
                        <linearGradient
                            id="waveGradient2"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="0%"
                        >
                            <stop
                                offset="0%"
                                stopColor="hsl(260 65% 55%)"
                                stopOpacity="0.02"
                            />
                            <stop
                                offset="50%"
                                stopColor="hsl(275 70% 60%)"
                                stopOpacity="0.08"
                            />
                            <stop
                                offset="100%"
                                stopColor="hsl(260 65% 55%)"
                                stopOpacity="0.02"
                            />
                        </linearGradient>
                    </defs>
                    {Array.from({ length: 15 }).map((_, i) => {
                        const y = (i + 1) * 6.5;
                        const qy = y - 2;
                        return (
                            <g
                                key={i}
                                className="animate-wave-flow"
                                style={{
                                    animationDelay: `${i * 0.4}s`,
                                }}
                            >
                                <path
                                    d={`M -400 ${y} Q -200 ${qy}, 0 ${y} T 400 ${y} T 800 ${y} T 1200 ${y} T 1600 ${y}`}
                                    stroke={
                                        i % 2 === 0
                                            ? 'url(#waveGradient1)'
                                            : 'url(#waveGradient2)'
                                    }
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    fill="none"
                                    vectorEffect="non-scaling-stroke"
                                />
                            </g>
                        );
                    })}
                </svg>
            </div>
        </>
    );
}
